var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.832 10.687a5.77 5.77 0 0 1-5.765 5.765 5.77 5.77 0 0 1-5.764-5.765 5.77 5.77 0 0 1 5.764-5.764 5.77 5.77 0 0 1 5.765 5.764Zm6.052 6.46-5.677 4.671-5.677-4.67h11.354Zm-5.189 6.261a.767.767 0 0 1-.977 0l-6.564-5.401v8.152H28.26v-8.152l-6.565 5.401Zm-17.387.699c0-3.537 1.743-6.85 4.664-8.862a.77.77 0 0 1 1.003.113 6.909 6.909 0 0 0 2.64 1.794v7.724H5.077a.769.769 0 0 1-.77-.77Z",
    fill: "#FCFAF8"
  })));
};

export default SvgCommunication;